import React from 'react';
import { jsx as _jsx } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";

var ReferralProgramCopy = function ReferralProgramCopy(_ref) {
  var activeReferralProgram = _ref.activeReferralProgram;
  return /*#__PURE__*/_jsxs("div", {
    children: [/*#__PURE__*/_jsx("h3", {
      className: "mt-0 text-lg",
      children: "Invite your friends, everybody saves."
    }), /*#__PURE__*/_jsxs("p", {
      className: "leading-6",
      children: ["For every friend that subscribes using your referral link, you'll get\xA0", activeReferralProgram.referrerDiscountPercentage, "% from their payments as credit toward your own subscription", activeReferralProgram.referrerDiscountDuration ? /*#__PURE__*/_jsxs(_Fragment, {
        children: [' ', "for ", activeReferralProgram.referrerDiscountDuration, ' ', activeReferralProgram.referrerDiscountDuration > 1 ? /*#__PURE__*/_jsx(_Fragment, {
          children: "months"
        }) : /*#__PURE__*/_jsx(_Fragment, {
          children: "month"
        }), ".", ' ']
      }) : /*#__PURE__*/_jsx(_Fragment, {
        children: ". "
      }), "They'll get ", activeReferralProgram.referredDiscountPercentage, "% off", activeReferralProgram.referredDiscountDuration ? /*#__PURE__*/_jsxs(_Fragment, {
        children: [' ', "for ", activeReferralProgram.referredDiscountDuration, ' ', activeReferralProgram.referredDiscountDuration > 1 ? /*#__PURE__*/_jsx(_Fragment, {
          children: "months"
        }) : /*#__PURE__*/_jsx(_Fragment, {
          children: "month"
        }), " too!"]
      }) : /*#__PURE__*/_jsx(_Fragment, {
        children: " too!"
      })]
    })]
  });
};

export default ReferralProgramCopy;